import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Tutorial from '../views/Tutorial.vue';
import DiseaseProgression from '../views/DiseaseProgression.vue';
import Visualization from '../views/Visualization.vue';
import References from '../views/References.vue';
import Glossary from '../views/Glossary.vue';
import Sitemap from '../views/Sitemap.vue'
import SearchResult from '../views/SearchResults.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "home",
    component: Home
  },
  {
    path: "/tutorial",
    name: "tutorial",
    component: Tutorial
  },
  {
    path: "/disease-progression",
    name: "disease-progression",
    component: DiseaseProgression
  },
  {
    path: "/visualization/:name/:year",
    name: "visualization",
    component: Visualization
  },
  {
    path: "/references",
    name: "references",
    component: References
  },
  {
    path: "/glossary",
    name: "glossary",
    component: Glossary
  },
  {
    path: '/sitemap',
    name: 'sitemap',
    component: Sitemap,
  },
  {
    path: "/search-results",
    name: "searchresults",
    component: SearchResult,
    // beforeEnter(to, from, next) {
    //   /* only allow access to 'results' route if users
    //   are at game end. otherwise, re-direct to home page.
    //   */
    //   if (router.app.$store.state.isGameEnd) {
    //     next();
    //   } else {
    //     next({ name: "home" });
    //   }
    // },
  },  
];

const router = new VueRouter({
  mode:'history',
  base:'/progression/visualizer/',
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

export default router

